import React, { Suspense } from 'react';
import CustomLoader from '../common/Loader/CustomLoader';
import errorBoundary from '../common/Loader/errorBoundary';

const Loadable = (Component) => errorBoundary((props) => (
  <Suspense fallback={<CustomLoader />}>
    <Component {...props} />
  </Suspense>
));

export default Loadable;
